import { FormattedMessage } from 'react-intl';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';

const EnrollmentInfo = ({ row }) => {
  const { name } = row.original;

  return (
    <FlexColumn>
      <Text element='span' textType={TextType.Paragraph} value={name || messages.defaultEnrollmentName} />
    </FlexColumn>
  );
};

export const createEnrollmentColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'enrollments',
  Header: (
    <div>
      <FormattedMessage {...messages.columnEnrolledFactors} />
    </div>
  ),
  Cell: EnrollmentInfo,
  width: 5,
});
